import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import translationEN from './locales/en/translation.json';
import translationID from './locales/id/translation.json';

const resources = {
    id: {
        translation: translationID
    },
    en: {
        translation: translationEN
    }
};

i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
        resources,
        debug: true,
        lng: 'id',
        fallbackLng: 'id',
        supportedLngs: ['id'],
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
        interpolation: {
            escapeValue: false
        },
        saveMissing: true,
    });

export default i18n;
